import React, { useEffect, useState } from 'react';
import { LOGO_URL, PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { useLanguage } from '../data/i18n';
import { LanguageToggle } from './LanguageToggle';
import { PhoneIcon } from './icons/Icons';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const {
    t
  } = useLanguage();
  const links = [{
    href: '#experiencia',
    label: t.nav.experience
  }, {
    href: '#servicios',
    label: t.nav.services
  }, {
    href: '#house-call',
    label: t.nav.houseCall
  }, {
    href: '#horario',
    label: t.nav.hours
  }, {
    href: '#reserva',
    label: t.nav.book
  }];
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${scrolled ? 'bg-black/90 backdrop-blur border-b border-white/10' : 'bg-transparent border-b border-transparent'}`} data-id="element-51" data-mp="3fb8bdyaryhot">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-52" data-mp="2rl8bwsahmh16">
        <div className={`flex items-center justify-between transition-all duration-500 ${scrolled ? 'h-16' : 'h-24'}`} data-id="element-53" data-mp="2rkgh3jopsnby">
          <a href="#top" className="flex items-center gap-3 group" data-id="element-54" data-mp="2hnlhexgpggw3">
            
            <span className="font-display text-bone tracking-[0.18em] text-lg sm:text-xl leading-none" style={{
            paddingLeft: "123px",
            fontWeight: "500",
            textAlign: "left",
            width: "300px",
            height: "26px"
          }} data-id="element-55" data-mp="2hpoiqdnb5wg4"><span className="text-white/50" style={{
              textAlign: "left"
            }} data-id="element-56" data-mp="3ad11ecqclk45">BARBER</span>VIP
            
              DUVAY</span>
          </a>

          <nav aria-label="Principal" className="hidden lg:flex items-center gap-9" data-id="element-57" data-mp="30mzcxju31zop">
            {links.map(l => <a key={l.href} href={l.href} className="font-sans text-[11px] uppercase tracking-[0.25em] text-ash hover:text-white transition-colors" data-id="element-58" data-mp="1wphmhaxsu5o">
                {l.label}
              </a>)}
          </nav>

          <div className="flex items-center gap-6 sm:gap-10" data-id="element-59" data-mp="1remfknrws8ia">
            <LanguageToggle data-id="element-60" data-mp="1wco5nsnr5839" />
            <a href={PHONE_HREF} className="inline-flex items-center gap-2 border border-white/40 px-4 py-2.5 font-sans text-[11px] uppercase tracking-[0.25em] text-bone hover:bg-white hover:text-black transition-colors" data-id="element-61" data-mp="1wcxrd41rkt35">
              <PhoneIcon className="w-4 h-4" data-id="element-62" data-mp="1mla1h7kuvk3s" />
              <span className="hidden sm:inline" data-id="element-63" data-mp="18nbpg8u0bzrg">{PHONE_DISPLAY}</span>
              <span className="sm:hidden" data-id="element-64" data-mp="18p6bxrkxfzxn">{t.nav.bookShort}</span>
            </a>
          </div>
        </div>
      </div>
    </header>;
}